import styled, { css } from "styled-components"

const CoverImageContainer = styled.div<{ modalMode?: boolean, embedded?: boolean }>`
  width: calc(100% + 40px);
  overflow: hidden;
  margin: 0px;
  padding-top: 56.25%;
  position: relative;
  margin-top: 20px;

  ${(props) => props.modalMode && css`
    // Specific to news modal
    margin-top: -40px;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: 20px;
  `}

  ${(props) => props.embedded && css`
    margin-top: 0;
    margin-bottom: 0;
    margin-left: -20px;
    margin-right: -20px;
  `}
`

export default CoverImageContainer